import PageManager from '../page-manager';

export default class Blog extends PageManager {}




// WEBPACK FOOTER //
// ./assets/js/theme/blog.js